import React from 'react'

export const Copy = () => {
  return (
    <div className="content_copy">
      <h3>  Juan Jose Murillo © 2021 </h3>
    </div>
  );
}
